<!-- ================管理端-主题活动详情====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">主题活动详情</div>
        </div>
        <div class="create-content-container">
            <div class="event-base-info-container">
                <div class="event-part1-l">
                    <div class="event-info-item-auto">
                        <span class="item-span">活动名称：</span>
                        {{activityForm.activityName}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">所属五馆：</span>
                        {{activityForm.museumName}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">所属主题：</span>
                        {{activityForm.activityItemName}}
                    </div>
                    <div class="event-info-item-auto" v-if="activityForm.museumKey === '4'">
                        <span class="item-span">四季主题：</span>
                        {{activityForm.seasonItemName}}
                    </div>
                    <div class="event-info-item-auto" v-if="activityForm.periodName">
                        <span class="item-span">学段：</span>
                        {{activityForm.periodName}}
                    </div>
                    <div class="event-info-item-auto" v-if="activityForm.activityGradeName">
                        <span class="item-span">年级段：</span>
                        {{activityForm.activityGradeName}}
                    </div>
                    <div class="event-info-item-auto" v-if="activityForm.activityAge">
                        <span class="item-span">活动年龄：</span>
                        {{activityForm.activityAge}}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">活动说明：</span>
                    </div>
                    <div class="excursion-overview" v-html="activityForm.activityDesc"></div>
                    <div class="event-info-item-auto">
                        <span class="item-span">活动目标：</span>
                    </div>
                    <div class="excursion-overview" v-html="activityForm.activityAim"></div>

                    <div class="event-info-item-auto">
                        <span class="item-span">活动资料：</span>
                    </div>
                    <div class="b-file-info-container">
                        <div class="b-file-list">
                            <div class="b-file-item" v-for="item in fileList" :key="item">
                                <div class="b-file-title">{{item.fileName}}</div>
                                <div class="b-file-view" title="预览" v-if="judgeIsFile(item.fileType)">
                                    <el-image @click="handleFIleStatus(item.status)" class="b-file-icon" style="margin-top: 5px"
                                              :src="require('@/assets/file/file_view.png')"
                                              :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                    </el-image>
                                </div>
                                <div class="b-file-view" title="播放" v-if="judgeIsPPT(item.fileType)">
                                    <el-image @click="viewPPTFile(item.fileUrl)" class="ppt-file-icon" style="margin-top: 5px"
                                              :src="require('@/assets/file/ppt_play.png')">
                                    </el-image>
                                </div>
                                <div class="b-file-view" title="播放" v-if="judgeIsVideo(item.fileType)">
                                    <el-image @click="openVideo(item.fileUrl)" class="b-file-icon" style="margin-top: 5px"
                                              :src="require('@/assets/file/file_bf.png')">
                                    </el-image>
                                </div>
                                <div class="b-file-download" title="下载">
                                    <img class="b-file-icon" @click="downloadFile(item)" style="margin-top: 3px" src="../../../assets/file/file_download.png" alt="">
                                </div>
                            </div>
                            <div v-if="fileList.length===0" class="data-empty">
                                <div class="empty-icon"><img src="../../../assets/image/data_empty.png" alt="" /></div>
                                <div class="empty-title">暂无附件</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="event-part1-r">
                    <div class="event-info-item-auto">
                        <span class="item-span">活动封面：</span>
                    </div>
                    <div class="event-base-info-cover">
                        <img class="img-100"  :src="activityForm.activityCover" alt="">
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!--音视频播放-->
    <el-dialog v-model="isShowVideo" width="76%" top="50px" @close="closeIframe">
        <iframe id="open-video" style="width: 100%;height:calc(100vh - 250px)" :src="videoSrc"
                frameborder="0"></iframe>
    </el-dialog>

</template>
<script>
import {serviceUrl} from "@/utils/global";
import {infoMuseumActivity} from "@/api/admin/museumActivity"
import {downloadFile} from "@/utils/download";

export default {
    components: {},
    name: "museumActivityDetail",
    data() {
        return {
            token: this.$storage.get("token"),
            serviceUrl,
            // 遮罩层
            loading: true,
            activityId:'',
            fileList:[],
            // 表单参数
            activityForm:{},  //数据
            isShowVideo:false,
            videoSrc:"",
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.activityId) {
            this.activityId = this.$route.query.activityId
            this.queryActivityInfo()
        }
    },
    mounted() {

    },
    methods: {
        backList(){
            this.$router.push({
                path: "/museumActivity",
            });
        },
        queryActivityInfo(){
            infoMuseumActivity({ activityId: this.activityId }).then(res => {
                if (res.data.code === 1) {
                    this.activityForm = res.data.data;
                    this.fileList = this.activityForm.fileList;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        /*============文件===========*/
        viewPPTFile(fileUrl){
            const openUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' +fileUrl;
            window.open(openUrl, '_blank')
        },
        judgeIsFile(fileType){
            if (!fileType){
                return false;
            }
            return fileType.toLowerCase().includes("pdf")||fileType.toLowerCase().includes("doc");
        },
        judgeIsVideo(fileType){
            if (!fileType){
                return false;
            }
            return fileType.toLowerCase().includes("mp4")||fileType.toLowerCase().includes("flv")||fileType.toLowerCase().includes("wmv");
        },
        judgeIsPPT(fileType){
            if (!fileType){
                return false;
            }
            return fileType.toLowerCase().includes("ppt");
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png?'+new Date());
            }
            return list;
        },
        /*============视频===========*/
        openVideo(url){
            this.videoSrc = url;
            this.isShowVideo = true;
        },
        closeIframe() {
            const iframe = document.getElementById("open-video"); // 获取到要关闭的iframe元素
            iframe.setAttribute("src", '');
            if (typeof iframe !== "undefined" && iframe !== null) {
                var contentWindow = iframe.contentWindow; // 获取到iframe内部的window对象
                if (typeof contentWindow !== "undefined" && contentWindow != null) {
                    contentWindow.close(); // 调用close()方法关闭iframe
                } else {
                    console.log("无效的iframe或者未加载完成！");
                }
            } else {
                console.log("没有找到指定的iframe元素！");
            }
        },
    },
}
</script>
<style>
.excursion-overview {
    margin-left: 10px;
    margin-top: 5px;
    width: calc(100% - 10px);
    font-size: 15px;
    line-height: 25px;
}
.excursion-overview img {
    max-width: 100%;
}
.excursion-overview table {
    width: 100%;
    border-collapse: collapse;
}
.avatar-uploader .avatar {
    height: 260px;
    width: 185px;
    display: block;
    object-fit: cover;
}
.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 260px;
    width: 185px;
    text-align: center;
}

.event-base-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.event-part1-l{
    width: calc(100% - 270px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.event-info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.event-part1-r{
    width: 270px;
    height: 100%;
}
.event-base-info-cover{
    width: 270px;
    height: 152px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}
.event-book-container{
    width: 85%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
    margin-left: 30px;
    margin-top: 5px;
    margin-bottom: 10px;
}
.book-list-one{
    width: 140px;
    height: 210px;
    margin-right: 10px;
    border: 1px solid #dcdfe6;
}
.book-cover{
    width: 140px;
    height: 180px;
}
.book-t{
    color: #333333;
    font-size: 15px;
    font-family: sans-serif;
    height: 30px;
    line-height: 30px;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略号 */
}
.item-span{
    font-weight: bold;
    color: #377f7f;
}
.b-file-info-container{
    width: 100%;
    height: auto;
}
.b-file-list{
    width: calc(100% - 60px);
    height: auto;
}
.b-file-item{
    display: flex;
    height: 30px;
    width: 100%;
    box-sizing: border-box;
}
.b-file-item:hover{
    color: #377f7f!important;
    font-weight: bold;
}
.b-file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    padding-left: 20px;
    box-sizing: border-box;
}
.b-file-view{
    width: 30px;
    height: 100%;
}
.b-file-download{
    width: 30px;
    height: 100%;
}
.b-file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.ppt-file-icon{
    width: 20px;
    height: 18px;
    cursor: pointer;
}
@media (max-width: 1024px) {
    .event-base-info-container { flex-direction: column; }
    .event-part1-l { width: 100%; padding-right: 0; }
    .event-part1-r { width: 100%; margin-top: 20px; }
    .event-base-info-cover { width: 240px; height: 135px; }
    .event-book-container { width: 100%; margin-left: 0; }
    .b-file-list { width: 100%; }
}
</style>
